<template>
  <article>
    <div class="all-menu" v-if="popupGbn == 0">
      <div class="header">
        <div class="close" @click="menuOpen = false">
          <i class="icon icon-m-close" />
        </div>
        <!-- 국가별 -->
        <div
          class="nation"
          @click="
            () => {
              (openedSetSiteInfoData = true), (popupGbn = 3);
            }
          "
        >
          <i :class="`icon icon-nation-${natCode}`" />
          <span class="name" v-if="siteCode == $config.SITECODE_OGHCM">{{ $t("ogvtn_국가명") }}</span>
          <span class="name" v-else>{{ $t(`${siteCode}_국가명`) }}</span>
        </div>

        <!--// 국가별 end -->
        <div class="user-info">
          <div v-if="!isLogin" class="branch wflex">
            <template v-if="siteCode == $config.SITECODE_OGHCM">
              <template v-if="isLogin">
                <template v-if="operGroupCd == 'VN1'">{{ $t(`${siteCode}_지점명칭`) }}</template>
                <template v-else>{{ $t(`oghni_지점명칭`) }}</template>
              </template>
              <template v-else>{{ /*국민은행 베트남 */ $t("MPAY-04-01-09-18") }}</template>
            </template>
            <template v-else>{{ $t(`${siteCode}_지점명칭`) }}</template>
          </div>
          <div v-if="isLogin" class="user">
            <template v-if="sessionInfo.userInfo.ppsnCoprDstcd == '1'">{{ sessionInfo.userInfo.userName }}</template>
            <template v-else>{{ sessionInfo.userInfo.sbidDstcd == "1" ? sessionInfo.userInfo.userName : sessionInfo.userInfo.subUserName }}</template>
          </div>
          <button
            v-if="!isLogin"
            class="btn-login"
            @click="
              () => {
                this.$router.push({ name: 'login' }), (menuOpen = false);
              }
            "
          >
            {{ /*로그인*/ $t("MLGI-01-01-01-07") }}
          </button>
          <button
            v-if="!isLogin && siteCode == $config.SITECODE_OGHCM"
            class="btn-login"
            @click="
              () => {
                this.$router.push({ name: 'joinServiceEnterVtn' }), (menuOpen = false);
              }
            "
          >
            {{ /* 회원가입 */ $t("EKYC-14-01") }}
          </button>
          <i v-if="isLogin" class="icon" :class="`${isCustNtc ? 'icon-nav-alarm-new' : 'icon-nav-alarm'}`" @click="goToNoticeService()" />
          <div class="news" @click="goToDetail()">
            <span class="date">{{ $getGlobalDateYmd(getLatestNews.regiYMS) }}</span>
            <span class="title" v-if="lang == 'KOR'" v-html="$htmlDecode(getLatestNews.hanglTitlCtnt)"></span>
            <span class="title" v-else-if="lang == 'ENG'" v-html="$htmlDecode(getLatestNews.engTitlCtnt)"></span>
            <span class="title" v-else v-html="$htmlDecode(getLatestNews.lcalTitlCtnt)"></span>
          </div>
        </div>

        <div class="top-nav">
          <div class="home" @click="goToMain"><i class="icon icon-s-home" />HOME</div>
          <div class="auth" @click="openPopup(1)">
            <i class="icon icon-auth" />
            {{ /*인증센터*/ $t("MMENU-0064") }}
          </div>
          <div class="return" v-show="reportAccount" @click="openPopup(2)">
            <i class="icon icon-return" />
            {{ /*사고신고*/ $t("MMENU-0052") }}
          </div>
        </div>
      </div>
      <div class="content">
        <div class="side-nav">
          <div class="tabs" id="tabs">
            <template v-for="(tab, index) in allmenu ? getMenuByLogin : getMenuByLogout">
              <template v-if="tab.name != 'reportAccountMmr' && tab.name != 'certificationCenter'">
                <button v-if="tab.isShow" class="tab-button tab-button--type1" :class="{ active: currentTab === index }" @click="currentTab = index" :key="index">
                  <span class="btn-text">{{ $t(tab.title) }}</span>
                </button>
              </template>
            </template>
          </div>
          <!-- allview : true, false 에 따라 아이콘이 변경 됨-->
          <button v-if="!isLogin" class="menu-show" :class="{ allview: allmenu }" @click="filterMenu">
            <i :class="[allmenu ? 'icon icon-open-arrow' : 'icon icon-fold-arrow']" />
            <!-- 펼치기 / 접기 -->
            {{ /*메뉴*/ $t("MMENU-0073") }} {{ !allmenu ? $t("MMENU-0074") : $t("MMENU-0075") }}
          </button>
          <button v-if="isLogin" class="logout" @click="FN003">
            <i class="icon icon-logout" />
            {{ /*로그아웃*/ $t("MCOM-0000055") }}
          </button>
        </div>
        <div class="side-nav-list">
          <template v-for="(m, i) in allmenu ? getMenuByLogin : getMenuByLogout">
            <div :key="i" v-if="m.isShow && m.name != 'reportAccountMmr' && m.name != 'certificationCenter' && currentTab == i">
              <ul v-for="(submenu, j) in m.children" :key="`${m}${j}-1`">
                <template v-if="submenu.isShow && submenu.children">
                  <li class="side-nav-list-item">
                    <div class="item" @click="goPage(submenu)" v-if="subMenuCheck(submenu.name) && submenu.isShow">{{ $t(submenu.title) }}</div>
                    <template v-for="(child, k) in submenu.children">
                      <ul class="depth-2" :key="`${j}-${k}`" v-if="isLogin || (!isLogin && child.name != 'vtnOtrbnkTrsaccInfoInptReqStep1')">
                        <li class="item" @click="goPage(child)" v-if="subMenu2DepthViewCheck(child.name) && child.isShow">{{ $t(child.title) }}</li>
                      </ul>
                    </template>
                  </li>
                </template>
                <li class="side-nav-list-item" v-else-if="submenu.isShow">
                  <div class="item" @click="goPage(submenu)">{{ $t(submenu.title) }}</div>
                </li>
              </ul>
            </div>
          </template>
        </div>
      </div>
    </div>

    <menu-popup v-else-if="popupGbn == 1 || popupGbn == 2" :popupGbn="popupGbn" :menuOpen.sync="menuOpen" />
    <choose-site-info
      v-else-if="popupGbn == 3"
      :opened.sync="openedSetSiteInfoData"
      @change="
        () => {
          menuOpen = false;
        }
      "
    />
    <modal-pop :opened.sync="mmQRPopupOpended" :modalHeader="true" :modalFooter="true" class="modal">
      <template #content>
        <div class="align-center">
          <i class="icon img-mmqr-logo"></i>
          <span class="v-hidden">
            MyanmarPay
            <em>MMQR</em>
          </span>
        </div>
        <div class="align-center">
          <h5 style="line-height:inherit">{{ /*Welcome to Myanmar Pay*/ $t("MPAY-07-01-01-38") }}</h5>
          <div>{{ /*Now you can easily make the different digital payments with Myanmar Pay.*/ $t("MPAY-07-01-01-39") }}</div>
        </div>
      </template>
      <template #footer>
        <button
          class="btn bottom positive"
          @click="
            () => {
              (mmQRPopupOpended = false), (menuOpen = false), $router.push({ name: 'mmQRAgreeTermsConditions' });
            }
          "
        >
          {{ /*확인*/ $t("FIDO-0096") }}
        </button>
      </template>
    </modal-pop>
    <modal-pop :opened.sync="mmQRRejectPopupOpended" :modalHeader="true" class="error">
      <template #content>
        <div>
          <div class="error-code">
            <i class="icon icon-error" />
            <div>
              <strong>{{ /*The service is currently not available.*/ $t("MPAY-07-01-01-40") }}</strong>
            </div>
          </div>
          <p>{{ /*Please contact KB Bank Myanmar for assistance.*/ $t("MPAY-07-01-01-41") }}</p>
          <p>{{ /*전화상담*/ $t("MCOM-0000031") }}</p>
          <div class="btn-area">
            <button class="btn lg inline" @click="$goToTel($t(`지점별콜번호_${siteCode}`))">
              <i class="icon icon-call" />
              {{ $t(`지점별전화번호_${siteCode}`) }}
            </button>
          </div>
        </div>
      </template>
      <template #footer>
        <button class="btn bottom positive" @click="mmQRRejectPopupOpended = !mmQRRejectPopupOpended">{{ /*확인*/ $t("MOTP-01-01-04-04") }}</button>
      </template>
    </modal-pop>
    <update-popup ref="versionUpdate" />
  </article>
</template>
<script>
import { mapFields } from "vuex-map-fields";
import { mapGetters, mapActions } from "vuex";
import { RBF0401P40 } from "@/mixins/main";
import MenuPopup from "@/components/layout/MenuPopup";
import ChooseSiteInfo from "@/components/page/main/ChooseSiteInfo";
import Common from "@/components/basic/Common";
import UpdatePopup from "@/components/layout/VersionUpdatePopup";

export default {
  name: "AllMenu",
  mixins: [RBF0401P40],
  extends: Common,
  components: { MenuPopup, ChooseSiteInfo, UpdatePopup },
  computed: {
    ...mapFields(["isMenuClick", "lang", "siteCode", "sessionInfo", "menuOpen", "operGroupCd", "addtlInfo"]),
    ...mapFields("common/main", ["isCustNtcInq", "isCustNtc"]),
    ...mapGetters(["isLogin", "getMenuByLogin", "getMenuByLogout", "isPersonalUser"]),
    ...mapGetters("common/main", ["getLatestNews"]),
    ...mapGetters(["isUserOtpDstcd"]),
    siteCodeData: {
      get() {
        return this.siteCode;
      },
      set(value) {
        this.actSiteCode(value);
        this.getNat();
      },
    },
    openedSetSiteInfoData: {
      get() {
        return this.openedSetSiteInfo;
      },
      set(value) {
        this.popupGbn = 0;
        this.openedSetSiteInfo = value;
      },
    },
  },
  async mounted() {
    this.getNat();
    await this.ACT_setLatestNews(this.operGroupCd);
    this.getReportAccount(); //사고신고 2차 오픈예정

    if (this.isLogin && !this.isCustNtcInq) {
      this.RBF0401P40mainCall();
    }
  },
  data() {
    return {
      currentTab: 0,
      tabs: [],
      allmenu: true,
      popupOpened: false,
      natName: "", //국가명
      natCode: "", //국가코드
      popupGbn: 0,
      customMenu: [],
      reportAccount: false,
      openedSetSiteInfo: false, //국가언어 설정 팝업
      mmQRPopupOpended: false, //MMQR 첫 사용 고객을 위한 팝업
      mmQRRejectPopupOpended: false, //MMQR 서비스 사용 거절 팝업
    };
  },
  methods: {
    ...mapActions(["actSiteCode", "ACT_EXEC_LOGOUT"]),
    ...mapActions("common/main", ["ACT_setLatestNews"]),
    getNat() {
      switch (this.siteCodeData) {
        case this.$config.SITECODE_OGCBD:
          this.natName = "CAMBODIA";
          this.natCode = "cam";
          break;
        case this.$config.SITECODE_OGMMR:
          this.natName = "MYANMAR";
          this.natCode = "mm";
          break;
        case this.$config.SITECODE_OGHCM:
          this.natName = "VIETNAM";
          this.natCode = "vn";
          break;
        case this.$config.SITECODE_OGAUC:
          this.natName = "NEW ZEALAND";
          this.natCode = "nz";
          break;
        case this.$config.SITECODE_OGIND:
          this.natName = "INDO";
          this.natCode = "ind";
          break;
      }
    },
    getReportAccount() {
      for (let item of this.getMenuByLogin) {
        if (item.name == "reportAccountMmr") {
          this.reportAccount = true;
        }
      }
    },
    goPage(obj) {
      if (obj.name === "mmQrPaymentStep1" && this.isLogin) {
        //QR스캔하기 전에 버전 확인 후, 하위 버전일 경우 업데이트 팝업 표출
        if (this.$refs.versionUpdate.checkVersion()) return;
        //미얀마 QR 스캔전 MMQR 진행상태 조회 거래 호출(RBF040A440)
        this.$post("/transfer/mntacc/MMQRPrgrsStusDstcd", {}, this.RBF040A440Suc);
      } else {
        this.menuOpen = false;

        if (obj.name == "findId") {
          this.isLogin ? this.$router.push({ name: "findIdByLogin" }) : this.$router.push({ name: obj.name });
        } else if (obj.name == "otrbnkTrsaccInfoInptReqStep1") {
          this.isLogin && this.siteCode == this.$config.SITECODE_OGHCM && (this.isUserOtpDstcd == "02" || this.isUserOtpDstcd == "03")
            ? this.$router.push({ name: "vtnOtrbnkTrsaccInfoInptReqStep1" })
            : this.$router.push({ name: obj.name });
        } else if (obj.name == "createEkyc" && this.isLogin) {
          this.sessionInfo.userInfo.nativYn == "1" ? this.$router.push({ name: obj.name }) : this.$router.push({ name: "createForgnEkycEnter" });
        } else {
          if (this.$route.name != obj.name) {
            this.isMenuClick = true;
          }
          console.log(JSON.stringify(obj));
          if (obj.name === "napasQrPaymentStep1") {
            // qr스캔 버튼을 클릭했을때 먼저 퍼미션 확인
            let permissions = ["1", "2"]; // 1 = camera, 2 = photo

            console.log("qr scan 버튼 클릭 -> 퍼미션 체크 ");
            this.$bridge.checkPermissions(permissions);
          } else {
            this.$router.push({ name: obj.name });
          }
        }
      }
    },
    RBF040A440Suc(res) {
      console.log("성공", res);
      let prgrsStusDstcd = res.outItem.prgrsStusDstcd;
      //prgrsStusDstcd(진행상태구분코드) 00:미가입, 01:가입, 91:가입실패, 99:서비스사용거절
      if (prgrsStusDstcd == "00" || prgrsStusDstcd == "91") {
        //onboading미가입
        //MMQR 팝업 , MMQR 서비스 약관동의 화면으로 이동
        this.mmQRPopupOpended = true;
      } else if (prgrsStusDstcd == "01") {
        console.log("성공");
        this.menuOpen = false;
        //onboading가입
        //QR스캔으로 위한 권한 체크
        let permissions = ["1", "2"]; // 1 = camera, 2 = photo
        this.$bridge.checkPermissions(permissions);
      }
      /* else if (prgrsStusDstcd == "90") {
        //onboading 가입 진행 중
        //failed 화면으로 이동
        this.$router.push({ name: "mmQRServiceJoinProcessing" });
      } else if (prgrsStusDstcd == "91") {
        this.menuOpen = false;
        //onboading가입실패
        //failed 화면으로 이동
        this.$router.push({ name: "mmQRServiceJoinFailed" });
      } */
      else if (prgrsStusDstcd == "99") {
        //서비스사용거절 onboading가입거절
        //서비스사용 거절 팝업
        this.mmQRRejectPopupOpended = true;
      }
    },
    goToMain() {
      if (this.$route.name == "main") {
        this.$parent.$parent.page = 1;
      } else {
        this.$router.push({ name: "main", params: { siteCode: this.siteCode, lang: this.lang } }); // 메인으로
      }
      this.menuOpen = false;
    },
    goToNoticeService() {
      // 알림서비스로 이동
      if (this.$route.name != "pushNotiStup") {
        this.$router.push({ name: "noticeService" });
        this.menuOpen = false;
      }
    },
    /**
     * 임시 로그아웃
     */
    FN003: async function () {
      await this.ACT_EXEC_LOGOUT();
      this.goMain();
      this.menuOpen = false;
    },
    openPopup(gbn) {
      // gbn === 1 인증센터 - FIDO 기기정보와 원장정보 get
      if (gbn === 1 && this.isLogin) {
        this.$store.dispatch("auth/createFido/act014_createFido");
      }
      this.popupGbn = gbn;
      this.$emit("update", gbn);
    },
    filterMenu() {
      this.allmenu = !this.allmenu;
      this.currentTab = this.allmenu ? 0 : 2;
    },
    goToDetail() {
      /*공지/새소식 상세페이지로 이동 */
      this.$router.push({
        name: "newsDetail",
        params: { serNo: this.getLatestNews.bltcSerno },
        query: { goBackPage: "main" },
      });

      this.menuOpen = false;
    },
    subMenu2DepthViewCheck(name) {
      if (name == "vtnOtrbnkTrsaccInfoInptReqStep1") {
        return this.siteCode == this.$config.SITECODE_OGHCM && this.isLogin && (this.isUserOtpDstcd == "02" || this.isUserOtpDstcd == "03");
      } else if (name == "cbmnetTrsaccInfoInptReqStep1" || name == "cbmnetTrsaccRsultInq") {
        return this.siteCode == this.$config.SITECODE_OGMMR;
      } else if (name == "otrbnkTrsaccInfoInptReqStep1") {
        return !(this.siteCode == this.$config.SITECODE_OGHCM && this.isLogin && (this.isUserOtpDstcd == "02" || this.isUserOtpDstcd == "03"));
      } else if (name == "mmQrPaymentStep1" || name == "mmQrPaymentHist") {
        return this.siteCode == this.$config.SITECODE_OGMMR && this.isLogin && this.isPersonalUser;
      } else {
        return true;
      }
    },
    subMenuCheck (name) {
      if (name == "mmQrPaymentStep1") {
        return this.siteCode == this.$config.SITECODE_OGMMR && this.isLogin && this.isPersonalUser;
      } else {
        return true;
      }
    },
  },
};
</script>
